// /frontend/src/pages/dashboard/post/previews/LinkedInPreview.js
import React from 'react';

const VIDEO_EXT   = ['.mp4', '.mov', '.webm', '.avi', '.m4v'];
const PLACEHOLDER = 'https://placehold.co/32x32/0A66C2/FFFFFF?text=IN';

const isVideoUrl = (url) =>
  url && VIDEO_EXT.some((ext) => url.toLowerCase().endsWith(ext));

function MediaItem({ url }) {
  if (!url) return null;
  const video = isVideoUrl(url);
  return video ? (
    <video src={url} controls style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 6 }} />
  ) : (
    <img src={url} alt="media" style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: 6 }} />
  );
}

function LinkedInMediaGrid({ files }) {
  const count = files.length;
  if (count === 1) {
    return (
      <div style={{ width: '100%', height: 250, borderRadius: 6, overflow: 'hidden', marginBottom: 8 }}>
        <MediaItem url={files[0].url} />
      </div>
    );
  }

  if (count === 2) {
    return (
      <div style={{ display: 'flex', width: '100%', height: 250, gap: 2, marginBottom: 8 }}>
        <div style={{ flex: 1, borderRadius: 6, overflow: 'hidden' }}>
          <MediaItem url={files[0].url} />
        </div>
        <div style={{ flex: 1, borderRadius: 6, overflow: 'hidden' }}>
          <MediaItem url={files[1].url} />
        </div>
      </div>
    );
  }

  if (count === 3) {
    return (
      <div style={{ width: '100%', height: 250, marginBottom: 8 }}>
        <div style={{ display: 'flex', gap: 2, height: '60%' }}>
          <div style={{ flex: 1, borderRadius: 6, overflow: 'hidden' }}>
            <MediaItem url={files[0].url} />
          </div>
          <div style={{ flex: 1, borderRadius: 6, overflow: 'hidden' }}>
            <MediaItem url={files[1].url} />
          </div>
        </div>
        <div style={{ display: 'flex', gap: 2, height: '40%', marginTop: 2 }}>
          <div style={{ flex: 1, borderRadius: 6, overflow: 'hidden' }}>
            <MediaItem url={files[2].url} />
          </div>
        </div>
      </div>
    );
  }

  // 4+ files: 2x2 grid, overlay +N on last cell if more than 4
  return (
    <div style={{
      display: 'grid',
      width: '100%',
      height: 250,
      gridTemplateColumns: '1fr 1fr',
      gridTemplateRows: '1fr 1fr',
      gap: 2,
      marginBottom: 8
    }}>
      {files.slice(0, 4).map((f, i) => (
        <div key={i} style={{ borderRadius: 6, overflow: 'hidden', position: 'relative', width: '100%', height: '100%' }}>
          <MediaItem url={f.url} />
          {i === 3 && files.length > 4 && (
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'rgba(0,0,0,0.5)',
              color: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              fontSize: 28,
              fontWeight: 700,
              borderRadius: 6
            }}>
              +{files.length - 4}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default function LinkedInPreview({
  account,
  files,
  caption,
  postType,
  scheduleDateTime,
}) {
  const avatar      = account?.userAvatar || account?.profileImage || account?.avatarUrl || PLACEHOLDER;
  const displayName = account?.displayName || 'Company Page';

  return (
    <div
      className="border rounded bg-white mb-3"
      style={{ maxWidth: 400, margin: '0 auto', fontFamily: 'Helvetica, Arial, sans-serif' }}
    >
      {/* header */}
      <div className="d-flex align-items-center p-2">
        <img
          src={avatar}
          alt="avatar"
          className="rounded-circle"
          style={{ width: 32, height: 32, objectFit: 'cover' }}
        />
        <strong className="ms-2">{displayName}</strong>
      </div>

      {/* media */}
      {files && files.length > 0 ? (
        <LinkedInMediaGrid files={files} />
      ) : (
        <div
          className="bg-light d-flex align-items-center justify-content-center"
          style={{ height: 200, color: '#999', borderRadius: 6, marginBottom: 8 }}
        >
          No media
        </div>
      )}

      {/* caption */}
      <div className="p-2">
        {caption ? (
          <p style={{ whiteSpace: 'pre-wrap', marginBottom: 6 }}>{caption}</p>
        ) : (
          <p className="text-muted" style={{ marginBottom: 6 }}>Caption will appear here</p>
        )}
        <small className="text-muted">
          {postType === 'schedule' && scheduleDateTime
            ? `Scheduled �6�1 ${new Date(scheduleDateTime).toLocaleString()}`
            : 'Just now'}
        </small>
      </div>
    </div>
  );
}
